import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { useTranslation as v } from "react-i18next";
import { LinearProgress as y, Box as l, Typography as s, Divider as D } from "@mui/material";
import { makeStyles as b } from "tss-react/mui";
import { useConfigContext as B } from "@lumirental/lumi-web-shared/lib/contexts/Config.context";
import { getPublicCDNLink as T } from "@lumirental/lumi-web-shared/lib/utils/cdnLinks";
import x from "../../../../common/Button/Button.js";
import N from "../../../../common/Dialogs/Responsive/ResponsiveDialog.js";
import W from "../../../../common/Image/Image.js";
import k from "./DifferentCityRegionDialog.style.js";
const p = b()(k), R = ({
  isOpen: o,
  onClose: n,
  dropOffChargesInfo: i,
  isLoading: r,
  onDropoffConfirm: d
}) => {
  const { classes: m } = p(), { t: a } = v(), { isMobile: e, appEnv: _ } = B(), u = e ? "column" : "row-reverse";
  return /* @__PURE__ */ c(
    N,
    {
      isMobile: e,
      open: o,
      onClose: n,
      dataTestid: "savedCardDialog",
      children: [
        r && /* @__PURE__ */ t(y, {}),
        /* @__PURE__ */ c(
          l,
          {
            sx: {
              padding: e ? 2 : 3,
              paddingTop: 0,
              textAlign: "center",
              minHeight: 340
            },
            className: m.contentWrapper,
            children: [
              (i == null ? void 0 : i.imgUrl) && /* @__PURE__ */ t(l, { sx: { marginBottom: e ? 3 : 1 }, children: /* @__PURE__ */ t(
                W,
                {
                  alt: "Drop place",
                  src: T(i == null ? void 0 : i.imgUrl, _),
                  width: 146,
                  height: 120
                }
              ) }),
              /* @__PURE__ */ c(l, { sx: { marginBottom: 3 }, children: [
                (i == null ? void 0 : i.title) && /* @__PURE__ */ t(
                  s,
                  {
                    sx: { marginBottom: 1 },
                    variant: "h2",
                    className: m.title,
                    children: i == null ? void 0 : i.title
                  }
                ),
                (i == null ? void 0 : i.description) && /* @__PURE__ */ t(s, { variant: "body", className: m.desc, children: i == null ? void 0 : i.description }),
                !e && /* @__PURE__ */ t(
                  D,
                  {
                    sx: {
                      marginTop: 3
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ c(
                l,
                {
                  sx: { display: "flex", flexDirection: u },
                  className: m.btnsWrapper,
                  children: [
                    /* @__PURE__ */ t(l, { children: /* @__PURE__ */ t(
                      x,
                      {
                        fullWidth: e,
                        dataTestid: "noKeepSaveCardBtn",
                        onClick: d,
                        sx: { minWidth: e ? 220 : 190 },
                        children: a("modal_primary_button_label_different_drop_off_charges")
                      }
                    ) }),
                    /* @__PURE__ */ t(l, { children: /* @__PURE__ */ t(
                      x,
                      {
                        variation: "text",
                        dataTestid: "saveCardRemoveBtn",
                        onClick: n,
                        sx: { minWidth: e ? 220 : 190, height: "100%" },
                        children: a("modal_secondary_button_label_choose_different_location")
                      }
                    ) })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, M = R;
export {
  M as default
};
